/**
 * Passwords are never stored as readable text. Each is kept as character codes
 * scrambled with a key, and visitor input is scrambled the same way before comparing.
 *
 * To change a password, encode the new one in the browser console:
 *   [...'NewPassword'].map((c) => c.charCodeAt(0) ^ 42)
 * and paste the resulting numbers into the matching list below.
 */
const KEY = 42;

/** Case studies (Kordis, Clear Docs). */
const CASE_STUDY_ENCODED = [121, 95, 65, 67, 65, 75, 94, 95, 106];

/** Playground → On my coffee table. Separate from the case-study password. */
const COFFEE_TABLE_ENCODED = [73, 75, 76, 79, 73, 67, 94, 69];

function matches(input: string, encoded: number[]): boolean {
  const codes = [...input.trim()].map((c) => c.charCodeAt(0) ^ KEY);
  return codes.length === encoded.length && codes.every((code, i) => code === encoded[i]);
}

export function matchesCaseStudyPassword(input: string): boolean {
  return matches(input, CASE_STUDY_ENCODED);
}

export function matchesCoffeeTablePassword(input: string): boolean {
  return matches(input, COFFEE_TABLE_ENCODED);
}
